import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, cloneElement, } from "react";
import { useTheme } from "styled-components";
import { Icon } from "../../icon";
// components
import { StyledAccordionTitle, StyledAccordionTitleWrapper, StyledAccordionTitleContainer, } from "./accordiontitle.styles";
// utils
import { makeDataTestIdGetter } from "../../utils";
export function AccordionTitle({ title, iconAlignment, stylingType, opened, onTitleClick, disabled, titleBold, fontSize = "p2", titlePreviewId, titleMargin, tag = "span", dataTestIdPrefix, }) {
    const isIconLeft = iconAlignment === "left";
    const [focused, setFocused] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const theme = useTheme();
    const tabIndex = disabled ? -1 : 0;
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    function renderIcon() {
        const iconColor = disabled
            ? `rgba(${theme.colors.transparentBlack},0.26)`
            : theme.colors.black;
        let symbolName = "chevron_down";
        if (isIconLeft) {
            symbolName = "chevron_right";
        }
        return (_jsx("div", Object.assign({ role: "tab", tabIndex: -1, onMouseDown: () => {
                setFocused(false);
                setIsActive(true);
            }, "data-testid": getDataTestId("accordion-title-icon") }, { children: _jsx(Icon, { symbol: symbolName, withHitSpace: true, color: iconColor }) })));
    }
    function renderContent() {
        const icon = renderIcon();
        const elements = [
            _jsx(StyledAccordionTitle, Object.assign({ as: tag, "data-preview-id": titlePreviewId, fontSize: fontSize, onMouseDown: () => {
                    setFocused(false);
                    setIsActive(true);
                }, stylingType: stylingType, isIconLeft: isIconLeft, "data-testid": getDataTestId("accordion-title-elements") }, { children: title })),
        ];
        if (isIconLeft) {
            elements.unshift(icon);
        }
        else {
            elements.push(icon);
        }
        return elements.filter(Boolean).map((element, key) => 
        // @ts-ignore
        cloneElement(element, { key: `acc-${String(key)}` }));
    }
    const isIconRight = iconAlignment === "right";
    return (_jsx(StyledAccordionTitleContainer, Object.assign({ titleMargin: titleMargin }, { children: _jsx(StyledAccordionTitleWrapper, Object.assign({ isIconRight: isIconRight, isOpened: Boolean(opened), disabled: disabled, hovered: hovered, isActive: isActive, focused: focused, stylingType: stylingType, isIconLeft: isIconLeft, titleBold: titleBold, fontSize: fontSize, tabIndex: tabIndex, onMouseOver: () => {
                setHovered(true);
            }, onMouseOut: () => {
                setHovered(false);
                setIsActive(false);
            }, onMouseDown: (event) => {
                setFocused(false);
                if (!disabled && (event === null || event === void 0 ? void 0 : event.target) === (event === null || event === void 0 ? void 0 : event.currentTarget)) {
                    // TODO write without tagName
                    setIsActive(true);
                }
            }, onKeyUp: (event) => {
                setFocused(!disabled);
                setIsActive(false);
                if (!disabled) {
                    if (event.key === "Enter" || event.key === "Space") {
                        if ((event === null || event === void 0 ? void 0 : event.target) === (event === null || event === void 0 ? void 0 : event.currentTarget) &&
                            typeof onTitleClick === "function") {
                            onTitleClick(event);
                        }
                    }
                }
            }, onBlur: () => {
                setFocused(false);
            }, onClick: (e) => {
                if (!disabled && onTitleClick) {
                    onTitleClick(e);
                }
            }, "data-testid": getDataTestId("accordion-wrapper"), "data-accordion-isopen": opened }, { children: _jsx(_Fragment, { children: renderContent() }) })) })));
}
